<template>
  <div>
    <el-form :model="form" :rules="rules" ref="form">
      <TopBarTitleComponent title="Directorio" :showBackIcon="showBackIcon">
        <template slot="right-area">
          <div class="d-flex justify-content-end align-items-center">
            <ButtonPrimaryComponent
              title="Guardar"
              @onSaveClick="handleSaveClick"
            />
            <button
              v-if="!showBackIcon"
              class="topbar-close-btn ml-3"
              @click="$emit('close')"
              title="Cerrar"
            >
              <i class="el-icon-close"></i>
            </button>
          </div>
        </template>
      </TopBarTitleComponent>

      <div class="dir-content-body">
        <!-- Breadcrumb -->
        <div class="dir-breadcrumb">
          <a @click="$router.push({ name: 'business.main' })">Directorio</a>
          <span class="dir-breadcrumb-sep">›</span>
          <span class="dir-breadcrumb-current">Nueva Empresa</span>
        </div>

        <!-- Segment tabs (mobile only) -->
        <div class="dir-internal-tabs d-lg-none">
          <button
            type="button"
            class="dir-tab"
            :class="{ active: mobileTab === 'data' }"
            @click="mobileTab = 'data'"
          >
            Datos
          </button>
          <button
            type="button"
            class="dir-tab"
            :class="{ active: mobileTab === 'contacts' }"
            @click="mobileTab = 'contacts'"
          >
            Contactos ({{ form.contacts.length }})
          </button>
        </div>

        <div class="dir-detail-layout">
          <!-- Left: Form -->
          <div
            class="dir-detail-main"
            v-show="mobileTab === 'data' || isDesktop"
          >
            <!-- Información básica + Logo -->
            <div class="dir-info-section">
              <h5 class="dir-info-section-title">Información básica</h5>
              <div class="add-basic-row">
                <!-- Logo (left on desktop, centered on mobile) -->
                <div class="add-logo-area">
                  <FileUploadComponent
                    title="Subir Logo"
                    :showFileList="false"
                    :preview="form.image"
                    :drag="true"
                    @fileBase64="onFileBase64"
                  />
                </div>
                <!-- Fields (right on desktop, below on mobile) -->
                <div class="add-basic-fields">
                  <b-row>
                    <b-col xs="12" sm="12" md="6">
                      <el-form-item prop="contact_type">
                        <label class="font-semi-bold m-0"
                          >Tipo de empresa</label
                        >
                        <el-select
                          v-model="form.contact_type"
                          placeholder="Seleccionar"
                        >
                          <el-option
                            v-for="(type, i) in businessTypes"
                            :key="i"
                            :label="type.name"
                            :value="type.id"
                          />
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col xs="12" sm="12" md="6">
                      <el-form-item prop="tradename">
                        <label class="font-semi-bold m-0"
                          >Nombre Comercial</label
                        >
                        <el-input type="text" v-model="form.tradename" />
                      </el-form-item>
                    </b-col>
                    <b-col xs="12" sm="12" md="6">
                      <el-form-item prop="email">
                        <label class="font-semi-bold m-0">Correo</label>
                        <el-input type="text" v-model="form.email" />
                      </el-form-item>
                    </b-col>
                    <b-col xs="12" sm="12" md="6">
                      <el-form-item prop="phone">
                        <label class="font-semi-bold m-0">Teléfono</label>
                        <el-input type="text" v-model="form.phone" />
                      </el-form-item>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>

            <!-- Información de facturación -->
            <div class="dir-info-section">
              <h5 class="dir-info-section-title">Información de facturación</h5>
              <b-row>
                <b-col xs="12" sm="12" md="6">
                  <el-form-item prop="document_type">
                    <label class="font-semi-bold m-0">Tipo de documento</label>
                    <el-select
                      v-model="form.document_type"
                      placeholder="Seleccionar"
                      @change="loadDefaultValue()"
                    >
                      <el-option
                        v-for="doc in documentTypes"
                        :key="doc.id"
                        :label="doc.name"
                        :value="doc.id"
                      />
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col xs="12" sm="12" md="6">
                  <el-form-item prop="document">
                    <label class="font-semi-bold m-0">Documento</label>
                    <el-input type="text" v-model="form.document" />
                  </el-form-item>
                </b-col>
                <b-col xs="12" sm="12" md="6">
                  <el-form-item prop="name">
                    <label class="font-semi-bold m-0">Razón Social</label>
                    <el-input type="text" v-model="form.name" />
                  </el-form-item>
                </b-col>
                <b-col xs="12" sm="12" md="6">
                  <el-form-item prop="address">
                    <label class="font-semi-bold m-0">Dirección</label>
                    <el-input type="text" v-model="form.address" />
                  </el-form-item>
                </b-col>
              </b-row>
            </div>

            <!-- Información complementaria -->
            <div class="dir-info-section">
              <h5 class="dir-info-section-title">Información complementaria</h5>
              <b-row>
                <b-col xs="12" sm="12" md="6">
                  <el-form-item prop="web">
                    <label class="font-semi-bold m-0">Sitio web</label>
                    <el-input type="text" v-model="form.web" />
                  </el-form-item>
                </b-col>
                <b-col xs="12" sm="12" md="6">
                  <el-form-item prop="city_id">
                    <label class="font-semi-bold m-0">Ciudad</label>
                    <el-select
                      filterable
                      v-model="form.city_id"
                      placeholder="Seleccionar"
                    >
                      <el-option
                        v-for="city in cities"
                        :key="city.id"
                        :label="city.name"
                        :value="city.id"
                      />
                    </el-select>
                  </el-form-item>
                </b-col>
              </b-row>
            </div>
          </div>

          <!-- Right: Contacts Panel (desktop) -->
          <div class="add-contacts-right d-none d-lg-block">
            <div class="contacts-panel">
              <div class="cp-header">
                <div style="display:flex;align-items:center">
                  <span class="cp-title">Contactos</span>
                  <span class="cp-count">{{ form.contacts.length }}</span>
                </div>
                <button
                  type="button"
                  class="cp-add-btn"
                  @click="openContactModal()"
                >
                  <PlusIcon :size="14" />
                  Agregar
                </button>
              </div>

              <div v-if="form.contacts.length === 0" class="cp-empty">
                <UserIcon :size="48" color="#e8e7e3" />
                <p class="cp-empty-text">Sin contactos aún</p>
                <button
                  type="button"
                  class="cp-empty-btn"
                  @click="openContactModal()"
                >
                  Agregar el primero
                </button>
              </div>

              <div v-else>
                <div
                  v-for="(contact, index) in form.contacts"
                  :key="index"
                  class="contact-item"
                  @click="openContactModal(index)"
                >
                  <div
                    class="c-av"
                    :style="{
                      background: getAvatarColor(index),
                      color: '#fff'
                    }"
                  >
                    {{ getInitials(contact.name) }}
                  </div>
                  <div class="c-info">
                    <p class="c-name">{{ contact.name || "Sin nombre" }}</p>
                    <p class="c-role">
                      {{ contact.position || contact.email }}
                    </p>
                  </div>
                  <button
                    type="button"
                    class="c-edit"
                    @click.stop="removeContact(index)"
                  >
                    <XIcon :size="14" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Mobile: Contacts tab content -->
          <div
            v-if="mobileTab === 'contacts' && !isDesktop"
            class="d-lg-none"
            style="width: 100%;"
          >
            <div class="contacts-panel" style="position: static;">
              <div class="cp-header">
                <div style="display:flex;align-items:center">
                  <span class="cp-title">Contactos</span>
                  <span class="cp-count">{{ form.contacts.length }}</span>
                </div>
                <button
                  type="button"
                  class="cp-add-btn"
                  @click="openContactModal()"
                >
                  <PlusIcon :size="14" />
                  Agregar
                </button>
              </div>

              <div v-if="form.contacts.length === 0" class="cp-empty">
                <UserIcon :size="48" color="#e8e7e3" />
                <p class="cp-empty-text">Sin contactos aún</p>
                <button
                  type="button"
                  class="cp-empty-btn"
                  @click="openContactModal()"
                >
                  Agregar el primero
                </button>
              </div>

              <div v-else>
                <div
                  v-for="(contact, index) in form.contacts"
                  :key="'m-' + index"
                  class="contact-item"
                  @click="openContactModal(index)"
                >
                  <div
                    class="c-av"
                    :style="{
                      background: getAvatarColor(index),
                      color: '#fff'
                    }"
                  >
                    {{ getInitials(contact.name) }}
                  </div>
                  <div class="c-info">
                    <p class="c-name">{{ contact.name || "Sin nombre" }}</p>
                    <p class="c-role">
                      {{ contact.position || contact.email }}
                    </p>
                  </div>
                  <button
                    type="button"
                    class="c-edit"
                    @click.stop="removeContact(index)"
                  >
                    <XIcon :size="14" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>

    <!-- Contact modal -->
    <div
      class="modal-overlay"
      v-if="dialogContact"
      @click.self="closeContactModal"
    >
      <div class="modal-box">
        <button type="button" class="modal-close" @click="closeContactModal">
          <XIcon :size="16" />
        </button>
        <div class="modal-body">
          <h2 class="modal-title">
            {{
              editingContactIndex !== null
                ? "Editar contacto"
                : "Agregar contacto"
            }}
          </h2>
          <p class="modal-sub">
            {{
              editingContactIndex !== null
                ? "Modifica los datos del contacto"
                : "Agrega un contacto a esta empresa"
            }}
          </p>

          <div class="modal-section-title">Información de Contacto</div>
          <div class="modal-form-grid">
            <div class="modal-form-field">
              <label>Nombre de contacto</label>
              <input v-model="contactForm.name" placeholder="Nombre completo" />
            </div>
            <div class="modal-form-field">
              <label>Correo</label>
              <input
                v-model="contactForm.email"
                placeholder="correo@empresa.com"
              />
            </div>
            <div class="modal-form-field">
              <label>Teléfono</label>
              <input
                v-model="contactForm.phone"
                placeholder="+593 99 000 0000"
              />
            </div>
            <div class="modal-form-field">
              <label>Cargo</label>
              <input
                v-model="contactForm.position"
                placeholder="Gerente, Contador..."
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn md__btn-primary"
              @click="saveContact"
            >
              {{
                editingContactIndex !== null
                  ? "Guardar cambios"
                  : "Agregar contacto"
              }}
            </button>
            <button
              type="button"
              class="btn md__btn-third-secondary"
              @click="closeContactModal"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBarTitleComponent from "../../components/TopBarTitle";
import FileUploadComponent from "../../components/FileUpload";
import ButtonPrimaryComponent from "../../components/ButtonPrimary";
import Validate from "@/assets/validate";
import businessService from "../services/businessService";
import CitiesServices from "@/services/CitiesServices";
import {
  documentTypes,
  businessTypes,
  validateDocumentByCountry
} from "@/services/Utils";
import { XIcon, UserIcon, PlusIcon } from "@/components/Icons/LucideIcons";

const AVATAR_COLORS = [
  "#6366f1",
  "#f59e0b",
  "#ef4444",
  "#8b5cf6",
  "#3fdbbf",
  "#ec4899",
  "#14b8a6",
  "#f97316",
  "#06b6d4",
  "#31355c"
];

export default {
  name: "BusinessAddComponent",
  components: {
    TopBarTitleComponent,
    FileUploadComponent,
    ButtonPrimaryComponent,
    XIcon,
    UserIcon,
    PlusIcon
  },
  props: {
    showBackIcon: { type: Boolean, default: true },
    // Mismo patrón que BusinessEditComponent (Edit.vue). Cuando este
    // formulario se usa embebido en un diálogo (ej. "+ Nuevo cliente" desde
    // cotización/factura vía SelectBusinessV2), debe avisar al padre con
    // onSuccess en vez de navegar a la página de edición — antes SIEMPRE
    // navegaba, sin importar el contexto, así que crear un cliente desde
    // una cotización/factura en progreso perdía todo lo ya llenado.
    isEmbedded: { type: Boolean, default: false }
  },
  computed: {
    currentCountryCode() {
      const user = this.$store.getters.getUser;
      return user && user.user_business
        ? user.user_business.country_code || "EC"
        : "EC";
    }
  },
  data() {
    const checkDocument = (rule, value, callback) => {
      if (!value) return callback();
      const { document_type } = this.form;
      switch (document_type) {
        case 1:
          if (value.length !== 13)
            return callback(new Error("RUC debe tener 13 dígitos"));
          break;
        case 2:
          if (value.length !== 10)
            return callback(new Error("Cédula debe tener 10 dígitos"));
          break;
        case 4:
          if (value.length !== 13 && value != 9999999999999)
            return callback(new Error("Consumidor Final: 9999999999999"));
          break;
        // Tipo 5 (Identificación del Exterior): sin restricción de longitud
        default:
          break;
      }
      // Validación algorítmica Ecuador si el negocio tiene country_code = EC
      const countryCode = this.currentCountryCode;
      const ecError = validateDocumentByCountry(
        document_type,
        value,
        countryCode
      );
      if (ecError) return callback(new Error(ecError));
      callback();
    };
    return {
      documentTypes,
      businessTypes,
      cities: [],
      mobileTab: "data",
      dialogContact: false,
      editingContactIndex: null,
      contactForm: { name: "", email: "", phone: "", position: "", image: "" },
      isDesktop: window.innerWidth >= 992,
      form: {
        name: "",
        tradename: "",
        email: "",
        document_type: "",
        document: "",
        address: "",
        phone: "",
        image: "",
        web: "",
        city_id: "",
        contact_type: "",
        contacts: []
      },
      rules: {
        tradename: [Validate.rules.required()],
        email: [Validate.rules.required(), Validate.rules.email()],
        document: [{ validator: checkDocument, trigger: "blur" }],
        contact_type: [Validate.rules.required("change")]
      }
    };
  },
  methods: {
    loadDefaultValue() {
      this.form.document = this.form.document_type == 4 ? "9999999999999" : "";
    },
    onFileBase64(base64) {
      this.form.image = base64;
    },
    getInitials(name) {
      if (!name) return "??";
      const parts = name.trim().split(/\s+/);
      if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
      return name.substring(0, 2).toUpperCase();
    },
    getAvatarColor(index) {
      return AVATAR_COLORS[index % AVATAR_COLORS.length];
    },
    openContactModal(index = null) {
      this.editingContactIndex = index;
      if (index !== null) {
        this.contactForm = { ...this.form.contacts[index] };
      } else {
        this.contactForm = {
          name: "",
          email: "",
          phone: "",
          position: "",
          image: ""
        };
      }
      this.dialogContact = true;
    },
    closeContactModal() {
      this.dialogContact = false;
      this.editingContactIndex = null;
    },
    saveContact() {
      if (!this.contactForm.name) {
        this.$notifications.error({ message: "El nombre es requerido" });
        return;
      }
      if (this.editingContactIndex !== null) {
        this.$set(this.form.contacts, this.editingContactIndex, {
          ...this.contactForm
        });
      } else {
        this.form.contacts.push({ ...this.contactForm });
      }
      this.closeContactModal();
    },
    removeContact(index) {
      this.form.contacts.splice(index, 1);
    },
    handleSaveClick() {
      // Un RUC/cédula pegado desde Excel/PDF/portal del SRI suele traer un
      // espacio invisible al inicio o al final — sin este trim, "value.length"
      // contaba ese espacio y fallaba "debe tener 13 dígitos" aunque el
      // usuario viera 13 dígitos correctos. Se recorta ANTES de validar para
      // que valide y guarde el mismo valor limpio que el usuario ve.
      if (this.form.document) {
        this.form.document = this.form.document.trim();
      }
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.$store.dispatch("toggleRequestLoading");
          try {
            let response = await businessService.addBusiness(this.form);
            if (response.data && response.data.success) {
              this.$notifications.success({ message: response.data.message });
              this.$refs.form.resetFields();
              this.form.contacts = [];
              this.form.image = "";
              this.$root.$emit("cleanFileUpload");

              if (this.isEmbedded) {
                // Embebido en un diálogo (ej. desde cotización/factura): el
                // padre (SelectBusinessV2) cierra el modal y selecciona el
                // cliente nuevo — nunca navegar fuera del documento en curso.
                this.$emit("onSuccess", { client: response.data.client });
              } else if (response.data.client && response.data.client.id) {
                this.$router.push({
                  name: "business.edit",
                  params: { id: response.data.client.id }
                });
              } else {
                this.$emit("onSuccess", { client: response.data.client });
              }
            } else if (response.data && response.data.message) {
              this.$notifications.error({ message: response.data.message });
            }
          } catch (error) {
            const msg =
              error.response && error.response.data
                ? error.response.data.message
                : "Error al guardar empresa";
            this.$notifications.error({ message: msg });
          } finally {
            this.$store.dispatch("toggleRequestLoading");
          }
        }
      });
    },
    async getCities() {
      try {
        let response = await CitiesServices.getCities();
        if (response.data.success) this.cities = response.data.cities;
      } catch (e) {
        return false;
      }
    },
    _handleResize() {
      this.isDesktop = window.innerWidth >= 992;
    },
    _handleEsc(e) {
      if (e.key === "Escape") this.closeContactModal();
    }
  },
  mounted() {
    this.getCities();
    window.addEventListener("resize", this._handleResize);
    document.addEventListener("keydown", this._handleEsc);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this._handleResize);
    document.removeEventListener("keydown", this._handleEsc);
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../theme/variables";

.topbar-close-btn {
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #909399;
  transition: all 0.15s;

  &:hover {
    background: #f0f2f7;
    color: #31355c;
  }
}

.el-form-item {
  margin-bottom: 8px !important;
}

// Logo + Info básica side by side in desktop
.add-basic-row {
  display: flex;
  gap: 24px;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }
}

.add-logo-area {
  flex-shrink: 0;
  width: 150px;

  ::v-deep .avatar-uploader {
    padding: 0;
    max-width: 150px;
  }

  ::v-deep .el-upload-dragger {
    padding: 20px 16px;
  }

  ::v-deep .avatar-uploader-icon {
    font-size: 36px;
    margin-bottom: 6px;
  }

  @media (max-width: 768px) {
    width: 160px;

    ::v-deep .avatar-uploader {
      max-width: 160px;
    }
  }
}

.add-basic-fields {
  flex: 1;
  min-width: 0;
}

.add-contacts-right {
  width: 280px;
  min-width: 280px;
  flex-shrink: 0;
  align-self: flex-start;
  position: sticky;
  top: 80px;
}
</style>
